import { useNavigate } from 'react-router-dom';
import { useFarmColumns } from '../utils/columns';
import { useUserSubscriptionStatus } from '../utils/hooks';
import FarmsView from './FarmsView';
import useCreateFarm from '../hooks/useCreateFarm';
import { MyProjectsQuery } from '../queries';

const MyProjectsView = () => {
  const navigate = useNavigate();
  const hasValidSubscription = useUserSubscriptionStatus();
  const { farmColumns } = useFarmColumns(MyProjectsQuery);
  const { createFarm } = useCreateFarm({
    refetchQuery: MyProjectsQuery,
  });

  const createButtonProps = {
    onClick: () =>
      hasValidSubscription ? createFarm() : navigate('/app/onboard'),
    showLockedBadge: !hasValidSubscription,
  };

  return (
    <FarmsView
      header="My Projects"
      searchPlaceholder="Search my projects by name or team"
      query={MyProjectsQuery}
      cols={farmColumns}
      sortColumn="objectUpdatedAt"
      sortDirection="desc"
      createButtonProps={createButtonProps}
    />
  );
};

export default MyProjectsView;
